module.exports = __webpack_public_path__ + "static/media/TOTAL-SCORE-3.9e77ae9f.png";